import axios from './util/axios.js'

export function getMe () {
  return axios.get('/api/clients/me/')
}
